import { render, staticRenderFns } from "./DevelopmentBanner.vue?vue&type=template&id=601330f6&scoped=true&"
import script from "./DevelopmentBanner.vue?vue&type=script&lang=js&"
export * from "./DevelopmentBanner.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentBanner.vue?vue&type=style&index=0&id=601330f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601330f6",
  null
  
)

export default component.exports